import React, {useState, useEffect} from "react";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import SchoolItem from "../Shared/Layout/SchoolItem";
import MapWrapper, {iconMarker} from "../Maps/Map";
import { Marker, Popup } from "react-leaflet";
import withLanguage from "../../HOC/withLanguage";
import Axios from "axios";
import Skeleton from "@mui/material/Skeleton";
import {useSelector} from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from "../Shared/Layout/Pagination";


let pageSize = 10;
function SchoolFilters({ onClick=()=>{}, language,}) {
    const [mapData, setMapData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(0);
    const [listData, setListData] = useState([]);
    const [category, setCategory] = useState("shkolla");
    const schoolFilter = useSelector(state=> state.schoolFilters.currentFilter)
    const [inputValue,setInputValue] = React.useState("");
    const [debouncedValue, setDebouncedValue] = useState(inputValue);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const openInGoogleMaps = (lat, lng) => {
        const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
        window.open(url, "_blank");
    };

    // On radio filter change
    const handleRadioChange= (event)=>{
        if(event.target.value === 'shkollat'){
            fetchSchools();
            setCategory("shkolla")
            setInputValue("");
        }else if(event.target.value === 'qendra'){
            fetchCenters();
            setCategory("qendra")
            setInputValue("");
        }else if(event.target.value === 'drejtimi_mesem'){
            fetchSchoolsAfter();
            setCategory("drejtimi_mesem")
            setInputValue("");
        }
        setPage(0)
    }

    useEffect(()=>{
        setCategory(schoolFilter)
    },[schoolFilter])

    //Get Schools List
    const fetchSchools = () => {
        setIsLoading(true);
        Axios.get(`/api/data/institution/shkolle_profesionale?dual_education__exact=true&page=${page+1}&per_page=${pageSize}`).then(response => {
            if (!response.data.error) {
                setListData(response.data)
                setMapData(response?.data?.records)
                setIsLoading(false)
            }
        }).catch(() => {
            setIsLoading(true)
        })
    }

    const fetchSchoolsAfter = () => {
        setIsLoading(true);
        Axios.get(`/api/data/institution/drejtimi_mesem?dual_education__exact=true&page=${page+1}&per_page=${pageSize}`).then(response => {
            if (!response.data.error) {
                setListData(response.data)
                setMapData(response?.data?.records)
                setIsLoading(false)
            }
        }).catch(() => {
            setIsLoading(true)
        })
    }


    //Get Formation Centers List
    const fetchCenters = () => {
        setIsLoading(true);
        Axios.get(`/api/data/institution/qender_formimi/${page+1}/${pageSize}`).then(response => {
            if (!response.data.error) {
                setListData(response.data)
                setMapData(response?.data?.records)
                setIsLoading(false)
            }
        }).catch(() => {
            setIsLoading(true)
        })
    }

    //Get Institution Search Data
    const getSearchData = () => {
        let url = (category==="drejtimi_mesem") ?  `/api/data/institution/drejtimi_mesem?dual_education__exact=true&name__iexact=${inputValue}` : `/api/data/institution/shkolle_profesionale?dual_education__exact=true&name__iexact=${inputValue}`;
       
        Axios.get(`${url}&page=${page+1}&per_page=${pageSize}`)
            .then((res) => {
                setListData(res.data);
                setMapData(res?.data?.records)
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const submitHandler = (e)=>{
        e.preventDefault();
        setPage(0);
        if (inputValue.trim() !== "") {
            getSearchData();
        } else {
            setCategory('shkolla');
            fetchSchools();
        }
    }

     useEffect(() => {
       getSearchData();
     }, [debouncedValue, category, page]);

     useEffect(() => {
       const handler = setTimeout(() => {
         setDebouncedValue(inputValue);
         setPage(0); 
       }, 500); // 500ms debounce delay

       return () => clearTimeout(handler);
     }, [inputValue]);




    return (


        <section className="flex-1">
            {/* Search Bar */}
            <div className="flex justify-center mb-12">
                <form
                    onSubmit={submitHandler}
                    className="flex overflow-hidden"
                >
                    <input
                        type="text"
                        placeholder={language.search}
                        className="w-[350px] border border-red-300 shadow-0 px-4 py-2 rounded-l-3xl focus:outline-none text-[17px]"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                    />

                    <button type="submit" className="bg-red-600 text-white px-6 rounded-r-2xl hover:bg-red-700 flex items-center justify-center opacity-85">
                        <SearchIcon className="h-5 w-5 text-white font-extrabold" />
                    </button>
                </form>
            </div>

            {/* Filters + Map + List */}
            <h2 className="text-red-600 font-extrabold text-[25px] mb-6">
                {language.filters}
            </h2>

            <div className="flex flex-col sm:flex-row gap-8">

                {/* Left side (Filters + Map) */}
                <div className="flex flex-col lg:flex-row gap-8">

                    <div className="lg:w-[670px] flex flex-col gap-6">

                        <FormGroup>
                            <RadioGroup
                                defaultValue="shkollat"
                                onChange={handleRadioChange}
                                sx={{flexDirection:'row'}}
                                className="flex md:flex-row"
                            >
                                <FormControlLabel
                                    value="shkollat"
                                    control={<Radio sx={{color: '#DB3222', '&.Mui-checked': {color: '#DB3222'}}}/>}
                                    label={language.title1Dual}
                                    checked={category === "shkolla"}
                                />
                                <FormControlLabel
                                    value="drejtimi_mesem"
                                    control={<Radio sx={{color: '#DB3222', '&.Mui-checked': {color: '#DB3222'}}}/>}
                                    label={language.title2}
                                    checked={category === "drejtimi_mesem"}
                                />
                            </RadioGroup>
                        </FormGroup>

                    {/* Map */}
                    <div className="md:h-[687px] h-[300px] w-full border-2 border-[#db3222]">
                        <MapWrapper>
                            {mapData?.map((item) => (
                                <Marker
                                    key={item.id}
                                    position={{ lat: item.latitude, lng: item.longitude }}
                                    icon={iconMarker}
                                >
                                    <Popup>
                                        <div className="max-w-[200px]">
                                            <span className="font-bold">{item.name} ({item?.municipality_id?.name})</span>
                                            <button
                                                className="text-[#DB3222] pt-1 flex mx-auto"
                                                onClick={() => openInGoogleMaps(item.latitude, item.longitude)}
                                            >
                                                {language.popupLink}
                                            </button>
                                        </div>
                                    </Popup>
                                </Marker>
                            ))}
                        </MapWrapper>
                    </div>
                </div>


                {/* Right side (Results) */}
                    <div className="lg:w-5/12 w-full">
                    <div>
                        {!isLoading ? listData?.records?.map((item) => (
                            <SchoolItem
                                key={item.id}
                                title={item.name}
                                qyteti={item?.municipality_id?.name}
                                id={item.id}
                                category={category}
                                variant="filterPage" 
                            />

                        ))  : (
                            <>
                                <Skeleton variant="rectangular" className="w-full mb-3" height={50}/>
                                <Skeleton variant="rectangular" className="w-full mb-3" height={50}/>
                                <Skeleton variant="rectangular" className="w-full" height={50}/>
                            </>)
                        }
                        {(!isLoading && !listData?.amount) ? <p className="text-gray-500">Nuk ka rezultate.</p> : null}
                    </div>
                
                    {listData?.amount>0 && <Pagination
                        count={listData?.amount}
                        pageSize={pageSize}
                        page={page}
                        action={handleChangePage}
                    />}
                    
                </div>

                </div>

            </div>
        </section>
    )
}

export default withLanguage(SchoolFilters, "Shkollat")


